import { Divider } from "antd";
import { useGetMeasurements } from "hooks/Measurement/useGetMeasurements";
import Dropdown from "Pages/User/ProductCatalog/AddNewProduct/Components/Dropdown";
import { ChangeEvent, useState } from "react";

const EditCatalogProduct = (selectedCatalog: any) => {
  const [data, setData] = useState(selectedCatalog?.selectedCatalog);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div>
      <div className="font-medium">Basic Information...</div>
      <Divider />
      <label htmlFor="name" className="mt-[30px] text-grey">
        Product Name
      </label>
      <input
        name="name"
        type="text"
        placeholder="Product Name"
        onChange={handleInputChange}
        value={data?.name}
        className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
      />

      <div className="flex gap-2">
        <div className="w-6/12">
          <label htmlFor="categories" className="mt-[30px] text-grey">
            Product Category
          </label>
          <div>
            <Dropdown
              placeholder={"--Select Categories--"}
              payload={data}
              setPayload={setData}
            />
          </div>
        </div>
        <div className="w-6/12">
          <label htmlFor="brandName" className="mt-[30px] text-grey">
            Brand
          </label>
          <input
            name="brandName"
            type="text"
            value={data?.brandName}
            onChange={handleInputChange}
            placeholder="Brand Name"
            className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
          />
        </div>
      </div>
      <div className="flex gap-2">
        <div className="w-6/12">
          <label htmlFor="unitPrice" className="mt-[30px] text-grey">
            Unit Price
          </label>
          <input
            name="unitPrice"
            type="text"
            value={data?.unitPrice}
            onChange={handleInputChange}
            placeholder="Enter Price"
            className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
          />
        </div>
        <div className="w-6/12">
          <label htmlFor="bulkPrice" className="mt-[30px] text-grey">
            Bulk Price
          </label>
          <input
            name="bulkPrice"
            type="text"
            value={data?.bulkPrice}
            onChange={handleInputChange}
            placeholder="Bulk Price"
            className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
          />
        </div>
      </div>
      <div className="">
        <label htmlFor="description" className="mt-[30px] text-grey">
          Product description
        </label>
        <textarea
          name="description"
          value={data?.description}
          onChange={handleInputChange}
          placeholder="Product description"
          className="resize-none h-[100px] px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        />
      </div>

      <div className="">
        <div className="font-medium">Stock Management</div>
        <Divider />
        <div className="">
          <div className="flex gap-2">
            <div className="w-4/12">
              <label
                htmlFor="unitStockMeasurement"
                className="mt-[30px] text-grey"
              >
                Unit Measurement
              </label>
              <select
                name="unitStockMeasurement"
                id=""
                className="px-6 py-4 bg-white text-[#a6a6a6] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  -Select option-
                </option>
                <option value="Gallon">Gallon</option>
                <option value="Carton">Carton</option>
                <option value="Pack">Pack</option>
                <option value="Row">Row</option>
                <option value="Kg">Kg</option>
                <option value="g">g</option>
                <option value="Sachet">Sachet</option>
              </select>
            </div>
            <div className="w-4/12">
              <label htmlFor="unitWeight" className="mt-[30px] text-grey">
                Unit Weight
              </label>
              <input
                name="unitWeight"
                type="text"
                value={data?.unitWeight}
                onChange={handleInputChange}
                placeholder="50g"
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
            <div className="w-4/12">
              <label htmlFor="unitPrice" className="mt-[30px] text-grey">
                Unit Price
              </label>
              <input
                name="unitPrice"
                type="text"
                value={data?.unitPrice}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-4/12">
              <label
                htmlFor="unitStockMeasurement"
                className="mt-[30px] text-grey"
              >
                Bulk Measurement
              </label>
              <select
                name="bulkStockMeasurement"
                id=""
                className="px-6 py-4 bg-white text-[#a6a6a6] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  -Select option-
                </option>
                <option value="Gallon">Gallon</option>
                <option value="Carton">Carton</option>
                <option value="Pack">Pack</option>
                <option value="Row">Row</option>
                <option value="Kg">Kg</option>
                <option value="g">g</option>
                <option value="Sachet">Sachet</option>
              </select>
            </div>
            <div className="w-4/12">
              <label htmlFor="bulkWeight" className="mt-[30px] text-grey">
                Bulk Weight
              </label>
              <input
                name="bulkWeight"
                type="text"
                value={data?.bulkWeight}
                onChange={handleInputChange}
                placeholder="25kg"
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
            <div className="w-4/12">
              <label htmlFor="bulkPrice" className="mt-[30px] text-grey">
                Bulk Price
              </label>
              <input
                name="bulkPrice"
                type="text"
                value={data?.bulkPrice}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6/12">
              <label
                htmlFor="bulkShippingMinQtyBetty"
                className="mt-[30px] text-grey"
              >
                Betty Min. Bulk Shipping
              </label>
              <input
                name="bulkShippingMinQtyBetty"
                type="text"
                value={data?.bulkShippingMinQtyBetty}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
            <div className="w-6/12">
              <label
                htmlFor="bulkShippingMaxQtyBetty"
                className="mt-[30px] text-grey"
              >
                Betty Max. Bulk Shipping
              </label>
              <input
                name="bulkShippingMaxQtyBetty"
                type="text"
                value={data?.bulkShippingMaxQtyBetty}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6/12">
              <label
                htmlFor="bulkShippingMinQtyUber"
                className="mt-[30px] text-grey"
              >
                Uber Min. Bulk Shipping
              </label>
              <input
                name="bulkShippingMinQtyUber"
                type="text"
                value={data?.bulkShippingMinQtyUber}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
            <div className="w-6/12">
              <label
                htmlFor="bulkShippingMaxQtyUber"
                className="mt-[30px] text-grey"
              >
                Uber Max. Bulk Shipping
              </label>
              <input
                name="bulkShippingMaxQtyUber"
                type="text"
                value={data?.bulkShippingMaxQtyUber}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6/12">
              <label
                htmlFor="bulkShippingMinQtyWalkIn"
                className="mt-[30px] text-grey"
              >
                Walk in Min. Bulk Shipping
              </label>
              <input
                name="bulkShippingMinQtyWalkIn"
                type="text"
                value={data?.bulkShippingMinQtyWalkIn}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
            <div className="w-6/12">
              <label
                htmlFor="bulkShippingMaxQtyWalkIn"
                className="mt-[30px] text-grey"
              >
                Walk in Max. Bulk Shipping
              </label>
              <input
                name="bulkShippingMaxQtyWalkIn"
                type="text"
                value={data?.bulkShippingMaxQtyWalkIn}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6/12">
              <label htmlFor="lowUnitStock" className="mt-[30px] text-grey">
                Low Unit Stock
              </label>
              <input
                name="lowUnitStock"
                type="text"
                value={data?.lowUnitStock}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
            <div className="w-6/12">
              <label htmlFor="lowBulkStock" className="mt-[30px] text-grey">
                Low Bulk Stock
              </label>
              <input
                name="lowBulkStock"
                type="text"
                value={data?.lowBulkStock}
                onChange={handleInputChange}
                placeholder=""
                className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              />
            </div>
          </div>
          {/* <button
            onClick={handleSubmit}
            className={`text-white p-[23px] w-full font-bold rounded-md ease-in-out duration-300 ${
              validity === false ? "bg-brown opacity-50" : "bg-orange"
            }`}
          >
            Complete
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default EditCatalogProduct;
